<div style="margin-left:10px;margin-top:100px;margin-right:10px;">
  <h3 style="color:red">Not Authorized</h3>
</div>